type GraphQLErrorLike = {
  message: string;
  extensions?: { code?: string };
};

type ApolloErrorLike = {
  graphQLErrors?: GraphQLErrorLike[];
};

export const getClientSafeErrorMessage = (error: unknown): string | null => {
  const apolloError = error as ApolloErrorLike;
  if (apolloError?.graphQLErrors && Array.isArray(apolloError.graphQLErrors)) {
    const clientSafeError = apolloError.graphQLErrors.find(
      (e) => e.extensions?.code === "CLIENT_SAFE_ERROR",
    );
    return clientSafeError?.message ?? null;
  }
  return null;
};
